import { createContext } from 'react';
import { Reference } from '../../interfaces';

interface ContextProps {
  reference: Reference | null;

  //Métodos
  addNewReference: (reference: Reference) => void
}

export const ReferencesContext = createContext({} as ContextProps);